import { StorageService } from './../../shared/services/storage.service';
import { Component,Renderer2, ViewChild } from '@angular/core';
import { AgGridI } from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import {StorageName } from 'src/app/shared/enum/common-enum';
import { DateRangeTypes } from 'src/app/shared/enum/common-enum';
import { CommonService } from 'src/app/shared/services/common.service';
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { RangeDatePickerComponent, SelectedDates } from 'src/app/shared/common-components/range-date-picker/range-date-picker.component';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DisplayBoardRegistrationService } from './display-board-registration.service';
import { AgGridDataModelDisplayBoardResistrationList, displayBoardRegistrationRequestModel } from './display-board-registration.model';
import { RegistrationList } from '../registration-list/registration-list.model';
import { ToastrService } from 'ngx-toastr';
import { CommonPopupComponent } from '../../shared/common-popup/common-popup.component';

@Component({
  selector: 'app-display-board-registration',
  templateUrl: './display-board-registration.component.html',
  styleUrls: ['./display-board-registration.component.scss']
})
export class DisplayBoardRegistrationComponent extends CommonService {
  agGridDataModelDisplayBoardResistrationList: AgGridI;
  rowData = [];
  timerId
  displayBoardRegistrationRequestModel = new displayBoardRegistrationRequestModel();
  totalRecords: number;
  @ViewChild(RangeDatePickerComponent) rangeDatePickerComponent: RangeDatePickerComponent;

  isCustomRange: any;

  getAllDropdown: any = {};
  storageName = StorageName;
  dateRangeTypes = DateRangeTypes;

  constructor(
    public displayBoardRegistrationService: DisplayBoardRegistrationService,
    public storageService: StorageService,
    public agGridService: AgGridService,
    public Renderer: Renderer2,
    public toaster: ToastrService,
    private ngbDateParserFormatter: NgbDateParserFormatter,
     private modalService : NgbModal,
  ) { super(Renderer); }

  ngOnInit(): void {
    this.agGridDataModelDisplayBoardResistrationList = AgGridDataModelDisplayBoardResistrationList;
    this.getDropdownData();
  }

  onGridReady($event) {
    this.agGridDataModelDisplayBoardResistrationList = $event;
    this.agGridDataModelDisplayBoardResistrationList.showPagination = true;
    this.displayBoardRegistrationRequestModel.getAll = false;
    this.displayBoardRegistrationRequestModel.pageNumber = 1;
    this.getAllRegistrationList();
  }

  getAllRegistrationList() {
    this.displayBoardRegistrationService.getAllRegistrationListData(this.displayBoardRegistrationRequestModel).subscribe(res => {
      console.log(res);
      if (res.isSuccess) {
        this.rowData = res?.response.data ?? [];
        this.totalRecords = res.totalRecords;
      } else {
        this.rowData = [];
        this.totalRecords = res.totalRecords;
      }
    })
  }

  deleteDisplayBoardResistration(event){
    let id = event.detail.data.data.id;
    this.displayBoardRegistrationService.deleteDisplayBoardRegistration({id}).subscribe((res)=>{
      if(res.isSuccess){
        this.toaster.success(res.message);
        this.getAllRegistrationList();
      }else{
        this.toaster.error(res.message);
      }
    })
  }

  ActiveInactiveDisplayBoard(data) {
    const rowdata = data?.detail?.data?.data;
    this.updateDisplayBoardRegistrationStatus(rowdata);
  }


  private formatEnumKey(key: string): string {
    return key.replace(/([a-z])([A-Z])/g, "$1 $2");
  }

  onChnagePage(event) {
    this.displayBoardRegistrationRequestModel.pageNumber = event?.pageNumber;
    this.displayBoardRegistrationRequestModel.pageSize = event?.pageSize;
    this.displayBoardRegistrationRequestModel.getAll = this.displayBoardRegistrationRequestModel.pageSize ===1;
    this.getAllRegistrationList()
  }
  searchFilter() {
    this.displayBoardRegistrationRequestModel.pageNumber = 1;
    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      this.getAllRegistrationList();
    }, 800);
  }


  range(event) {
    this.isCustomRange = event;
    if (this.isCustomRange != this.dateRangeTypes.CustomRange) {
      const currentDate = new Date();
      if (this.dateRangeTypes.ThisMonth == event) {
        this.displayBoardRegistrationRequestModel.fromDate = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
        this.displayBoardRegistrationRequestModel.toDate = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
      } else if (this.dateRangeTypes.LastMonth == event) {
        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);

        this.displayBoardRegistrationRequestModel.fromDate = this.formatDate(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth(), 1))
        this.displayBoardRegistrationRequestModel.toDate = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 0));
      } else if (this.dateRangeTypes.YearToDate == event) {
        this.displayBoardRegistrationRequestModel.fromDate = this.formatDate(new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate())); // Current date of last year
        this.displayBoardRegistrationRequestModel.toDate = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
      }
      this.getAllRegistrationList()
    } else if (this.isCustomRange == this.dateRangeTypes.CustomRange) {
      setTimeout(() => {
        this.rangeDatePickerComponent.inputDate = null;
      }, 100);
    }

  }


  getDropdownData() {
    this.agGridService.getAllDropdownList().subscribe(() => {
      this.getAllDropdown.dateRangeDropdown = this.storageService.retrieve(StorageName.DATE_RANGE_DROPDOWN);
    })
  }

  selectedRangeDates(selectedDates: SelectedDates) {
    console.log('selectedRangeDates');
    if (selectedDates?.endDate && selectedDates?.startDate) {
      const startdate = this.ngbDateParserFormatter.format(selectedDates?.startDate);
      const endtdate = this.ngbDateParserFormatter.format(selectedDates?.endDate);
      const datePipe = new DatePipe('en-US');
      this.displayBoardRegistrationRequestModel.fromDate = datePipe?.transform(startdate, "yyyy-MM-ddT00:00:00");
      this.displayBoardRegistrationRequestModel.toDate = datePipe?.transform(endtdate, "yyyy-MM-ddT00:00:00");
      this.getAllRegistrationList()
    }
  }


  selectedRangeDatesClear() {
    this.displayBoardRegistrationRequestModel.fromDate = '';
    this.displayBoardRegistrationRequestModel.toDate = '';
    this.getAllRegistrationList()
  }

  updateDisplayBoardRegistrationStatus(data){
    const requestData ={id: data.id,active:data.active}
    this.displayBoardRegistrationService.updateDisplayBoardRegistrationStatus(requestData).subscribe(res => {
      if (res.isSuccess) {
        this.toaster.success(res.message);
        this.getAllRegistrationList()
      } else {
      }
    })
  }
}


